"use strict";
'use strict';

$(document).on('click', function (e) {
  var target = $(e.target);
  if (target.closest('.sort-by--wrap').length) {
    $('.sort-by--wrap').toggleClass('opened');
  } else {
    $('.sort-by--wrap').removeClass('opened');
  }
});
"use strict";

$(document).on("click", ".product-card__quick-add-button", function (e) {
  e.preventDefault();
  e.stopImmediatePropagation();
  var btn = $(this);
  var product = btn.closest(".product-card");
  $(".product-card").removeClass("qa-opened");
  product.addClass("qa-opened");
  product.find(".product-card__quick-add-inner").click();
});

$(document).on("click", function (e) {
  var target = $(e.target);
  if (target.closest(".product-card__quick-add-inner").length && !target.is(".product-card__quick-add-close") && !target.closest(".product-card__quick-add-close").length) {
    var modal = target.closest(".product-card__quick-add-inner");
    var mainPrice = modal.find(".product-card__quick-add-price");
    setTimeout(function () {
      var visibleForm = modal.find("form:visible");
      if (mainPrice.length) {
        var visibleForm = modal.find("form:visible");
        var newPriceEl = visibleForm.find(".omb-product-price__container .product__price");
        if (newPriceEl.length) {
          var newPriceText = newPriceEl.text().trim();
          var newPriceHtml = newPriceEl.html();
          if (newPriceText && newPriceText.length > 1) {
            mainPrice.html(newPriceHtml);
          }
        }
      }
    }, 0);
  } else {
    if (!target.is(".product-card__quick-add-button")) {
      $(".product-card").removeClass("qa-opened");
    }
  }
});

$(document).on("change", '.product-card__quick-add-modal .selector-wrapper select[name="id"]', function (e) {
  var form = $(this).closest("form");
  var priceGroup = form.find("[data-price]");
  var newPrice = $(this).find("option:selected").attr("data-price");
  var comparePrice = $(this).find("option:selected").attr("data-compare-price");
  newPrice = parseInt(newPrice);
  comparePrice = parseInt(comparePrice);
  var isSale = false;
  if (comparePrice && comparePrice > newPrice) {
    isSale = true;
    comparePrice = theme.Currency.formatMoney(comparePrice, theme.moneyFormat);
  }
  newPrice = theme.Currency.formatMoney(newPrice, theme.moneyFormat);

  if (isSale) {
    priceGroup.addClass('price--on-sale');
    priceGroup.find('[data-sale-price]').text(newPrice);
    priceGroup.find('[data-regular-price]').text(comparePrice);
  } else {
    priceGroup.removeClass('price--on-sale');
    priceGroup.find('[data-regular-price]').text(newPrice);
  }
});
'use strict';

var wrap = $('.collection-quiz-wrap');
if (wrap.length) {
    var position = wrap.attr('data-element-position');
    var element = wrap.find('.shopify-section').detach();
    if (position.indexOf('row') > -1) {
        var setOnRow = function setOnRow() {
            element.detach();
            var elementsInRow = 1;
            if ($(window).width() < 600) {
                elementsInRow = 1;
            } else if ($(window).width() < 750) {
                elementsInRow = 2;
            } else {
                elementsInRow = 3;
            }
            var appendAfter = elementsInRow * row;

            $('#Collection > .grid > li:nth-of-type(' + appendAfter + ')').after(element);
        };

        var row = position.replace('row-', '');
        element.addClass('grid__item');

        setOnRow();
        $(window).on('resize', setOnRow);
        wrap.hide();
    } else {
        if (position == 'top') {
            $('#shopify-section-collection-template').prepend(element.detach());
            wrap.hide();
        } else if (position == 'bottom') {
            //Do nothing
        } else if (position == 'hide') {
            wrap.hide();
        }
    }
}
'use strict';

function checkReviewsCount() {
  $(document).find('.product-card__reviews').each(function () {
    var el = $(this);
    var hasReviews = el.find('.yotpo-custom-wrapper[data-product-id]').find('.yotpo-icon').length;
    if (hasReviews) {
      el.find('.yotpo-custom-wrapper[data-product-id]').show();
      el.find('.yotpo-custom-wrapper.yotpo-skeleton').hide();
    } else {
      el.find('.yotpo-custom-wrapper.yotpo-skeleton').show();
      el.find('.yotpo-custom-wrapper[data-product-id]').hide();
    }
  });
}
function checkYotpo() {
  if (typeof yotpo !== 'undefined' && typeof yotpo.onAllWidgetsReady !== 'undefined') {
    yotpo.onAllWidgetsReady(checkReviewsCount);
  } else {
    setTimeout(function () {
      checkYotpo();
    }, 100);
  }
}
checkYotpo();